import React, { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  Box,
  Link,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Styles from "../../styles/_global/Styles";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [emailSent, setEmailSent] = useState(false);

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    setSubmitting(true);

    const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
    try {
      const res = await axios.post(`${backendUrl}/forgot-password`, { email });
      console.log(res.data);
      setSuccessMessage(
        "If there is an account associated with this email, we have sent a password reset link."
      );
      setEmailSent(true);
    } catch (err) {
      setError(
        err.response
          ? err.response.data.error
          : "Unable to process request, please try again later."
      );
      setSubmitting(false);
    }
  };

  return (
    <Container
      component="main"
      maxWidth="sm"  // Adjusted from "xs" to "sm" to allow more space for the form
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        minWidth: "100vw",
        backgroundColor: "#f4f4f4",
        backgroundImage: 'url("/assets/bg-repeat-01.png")',
        backgroundRepeat: "repeat",
      }}
    >
      <img
        src="/assets/logo-dark.svg"
        alt="Logo"
        style={{ marginBottom: 20, width: 200 }}
      />

      <Paper
        elevation={3}
        sx={{
          padding: 4,
          borderRadius: 3,
          width: "100%", // Ensure the Paper uses the full width available
          maxWidth: "400px",  // Adjust this value to match your design needs
          boxShadow:
            "0px 4px 15px rgba(0, 0, 0, 0.05), 0px 2px 6px rgba(0, 0, 0, 0.05)",
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography component="h1" variant="h5" gutterBottom>
            Forgot Password
          </Typography>

          {!emailSent && (
            <Typography variant="body2" color="textSecondary" align="center">
              Enter the email address associated with your account and we will
              email you a link to reset your password.
            </Typography>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, width: "100%" }}>
            <Grid container spacing={2}>
              {!emailSent && (
                <Grid item xs={12}>
                  <TextField
                    name="email"
                    label="Email Address"
                    fullWidth
                    value={email}
                    onChange={handleInputChange}
                    required
                    type="email"
                    variant="outlined"
                    InputProps={{
                      style: { borderRadius: 8 },
                    }}
                  />
                </Grid>
              )}

              {error && (
                <Grid item xs={12}>
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                </Grid>
              )}

              {successMessage && (
                <Grid item xs={12}>
                  <Typography color="primary" variant="body2">
                    {successMessage}
                  </Typography>
                </Grid>
              )}
            </Grid>

            {!emailSent && (
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{
                  marginTop: 3,
                  marginBottom: 2,
                  padding: "10px 0",
                  borderRadius: 8,
                  backgroundColor: Styles.primary.main,
                  "&:hover": {
                    backgroundColor: Styles.secondary.main,
                  },
                  textTransform: "none",
                  color: "#fff",
                }}
                disabled={submitting ? true : false}
              >
                {submitting ? "Sending..." : "Send Reset Link"}
              </Button>
            )}

             {/* Go to Sign In */}
            <Grid container justifyContent="center" sx={{ marginTop: emailSent ? 2 : 0 }}>
              <Grid item>
                <Link
                  component="button"
                  onClick={() => navigate("/signin")}
                  variant="body2"
                  sx={{
                    cursor: "pointer",
                    textDecoration: "none",
                    fontWeight: "bold",
                    color: Styles.primary.main,
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  Back to Sign In
                </Link>
              </Grid>
            </Grid>
            
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default ForgotPassword;
